/**
 * Parses a lede string with **bold** markers into a span tree.
 *
 * Designer's copy rule (Home v1 spec §5 + product lede §3.5) is that every
 * product lede gets exactly one emphasis phrase wrapped in `<strong>`, and
 * hero ledes may have 2–3. Storing the emphasis inline with asterisks keeps
 * the data file readable without coupling it to JSX.
 */

import React from "react";
import { Box } from "@mui/material";

interface BoldLedeProps {
  text: string;
  /** Optional sx passthrough for the wrapping span. */
  sx?: React.ComponentProps<typeof Box>["sx"];
}

export default function BoldLede({ text, sx }: BoldLedeProps) {
  const parts = text.split(/\*\*(.+?)\*\*/g);
  return (
    <Box component="span" sx={sx}>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <Box
            component="strong"
            key={i}
            sx={{ color: "text.primary", fontWeight: 500 }}
          >
            {part}
          </Box>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        ),
      )}
    </Box>
  );
}
